/**
 * Extracts advertising IDs and UTM parameters from the URL query string
 * @returns Record of ad tracking parameters found in URL
 */
export const getAdsIdsFromUrl = (): Record<string, string | null> => {
  // Only run in browser environment
  if (typeof window === 'undefined') {
    return {};
  }

  const searchParams = new URLSearchParams(window.location.search);

  // Define the query parameters we want to track
  const trackingParams = [
    'gclid',
    'gbraid',
    'fbclid',
    'wbraid',
    'ttclid',
    'yclid',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term',
    'rdt_cid',
    'initial_twclid',
    'twclid',
    'msclkid',
    'dclid',
  ];

  // Clean query parameter values
  const cleanValue = (value: string | null): string | null =>
    value?.trim().replace(/%22/g, '').replace(/"/g, '') || null;

  // Extract each parameter if it exists in the URL
  const result: Record<string, string | null> = {};
  trackingParams.forEach((param) => {
    const value = searchParams.get(param);
    result[param] = cleanValue(value);
  });

  return result;
};

export default getAdsIdsFromUrl;
